import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Input, Button, Checkbox , Space} from "antd";
import { Row, Col, Alert, Select,Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import AuthBg from "../../components/background/AuthBg";
import {QuestionCircleOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {authActions, dataActions, tutorAuthActions} from "_actions";
import { Steps } from "antd";

import ReCAPTCHA from "react-google-recaptcha"
import "../../assets/sass/auth.scss";
import {history} from "../../_helpers";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import luxfi from "../../assets/img/lux-register-no-bg.png";

import {PasswordInput} from 'antd-password-input-strength'
import {xcService} from "../../_services/xcService";
import { noCaptcha } from "_config";
const { Step } = Steps;

const { Option } = Select;
const layout = {
  labelCol: {
    span: 18,
  },
  wrapperCol: {
    span: 24,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
function RegisterPage(props) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const captchaRef = useRef(null)
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptlegal, setAcceptLegal] = useState(false);
  const [acceptconfirma, setAcceptConfirma] = useState(false);
  const [acceptconsiente, setAcceptConsiente] = useState(false);
  const [acceptdeclara, setAcceptDeclara] = useState(false);
  const [nameCenter, setNameCenter] = useState(null)
  const [acceptmail, setAcceptMail] = useState(false);
  const [acceptconoce, setAcceptConoce] = useState(false);
  const [acceptcentermanifiesta, setAcceptCenterManifiesta] = useState(false);
  const [acceptcenter, setAcceptCenter] = useState(false);
  const [acceptcenterdeclara, setAcceptCenterDeclara] = useState(false);
  const [values, setValues] = useState(null);
  const [valsOne, setValsOne] = useState(null);
  const [errorCenter, setErrorCenter] = useState(false)
  const [perfil, setPerfil] = useState(1);
  const [current, setCurrent] = useState(0);
  const [level, setLevel] = useState(0)
  const [courses, setCourses] = useState([]);
  const [professions, setProfessions] = useState([]);
  const minLevel = 0;
  const errorMessage = t("cuenta.debil");
  const onAcceptConoceChange = async (e) => {
    await setAcceptConoce(e.target.checked);
    form.validateFields(['checkbox']);
  };

  const onAcceptDeclaraChange = async (e) => {
    await setAcceptDeclara(e.target.checked);
    form.validateFields(['checkbox']);
  };

  const onAcceptMailChange = async (e) => {
    await setAcceptMail(e.target.checked);
    form.validateFields(['checkbox']);
  };

  const onAcceptCenterManifiestaChange = async (e) => {
    await setAcceptCenterManifiesta(e.target.checked);
    form.validateFields(['checkbox']);
  };

  const onAcceptCenterChange = async (e) => {
    await setAcceptCenter(e.target.checked);
    form.validateFields(['checkbox']);
  };

  const onAcceptCenterDeclara = async (e) => {
    await setAcceptCenterDeclara(e.target.checked);
    form.validateFields(['checkbox']);
  };


  const [showErrorCheck, setShowErrorCheck] = useState(false);
  const [error, setError] = useState(false);
  const [codeError, setCodeError] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  var registerUser = useSelector((state) => state.authReducer.registerUser);
  var registerUserError = useSelector(
      (state) => state.authReducer.registerUserError
  );

  var checkCodeCenter = useSelector((state) => state.authReducer.checkCodeCenter);
  var checkCodeCenterError = useSelector(
      (state) => state.authReducer.checkCodeCenterError
  );
  var coursesData = useSelector((state) => state.dataReducer.coursesData);

  var professionsData  = useSelector((state) => state.dataReducer.professionsData);

  var registerCenterData = useSelector((state) => state.tutorAuthReducer.registerCenterData);
  var registerCenterError = useSelector(
      (state) => state.tutorAuthReducer.registerCenterError
  );



  useEffect(() => {
    setLoading(false);

    if (registerCenterData) {
      setError(false);
      setErrorMsg("");
      setCurrent(6)
    }
    if (registerCenterError) {

      setError(true);
      setErrorMsg(t(registerCenterError.code));
    }
  }, [registerCenterData, registerCenterError]);

  useEffect(() => {
    if (!coursesData) getCourses();

    if (!professionsData) getProfessions();
  }, []);


  useEffect(() => {
    setLoading(false);

    if (registerUser) {
      setError(false);
      setErrorMsg("");
      setCurrent(6);
    }
    if (registerUserError) {

      setError(true);
      setErrorMsg(t(registerUserError.code));
    }
  }, [registerUser, registerUserError]);

  const getCourses = () => {
    dispatch(dataActions.getCourses());
  };
  useEffect(() => {
    if (coursesData) setCourses(coursesData);


  }, [coursesData]);

  useEffect(() => {
    if (professionsData) setProfessions(professionsData);


  }, [professionsData]);

  const getProfessions = () => {
    dispatch(dataActions.getProfessions());
  };
  useEffect(() => {
    if (coursesData) setCourses(coursesData);

    if (coursesData) setCourses(coursesData);
  }, [coursesData]);


  const onFinishStep1 = (vals) => {
    setValsOne(vals);
    setErrorCenter(null);

   // setValues({...values, ...vals});
    dispatch(authActions.checkCode({centerCode: vals.centerCode, passwordCenter: vals.passwordCenter}));
    setLoading(true)
   // setCurrent(2)
  };

  useEffect(() => {
    if (checkCodeCenter){

      setValues({...values, ...valsOne})
      setCurrent(2)
      setLoading(false)
    }
    if (checkCodeCenterError){
      setCodeError(checkCodeCenterError?.code)
      setLoading(false)
      setErrorCenter(true);
    }

  },[ checkCodeCenter, checkCodeCenterError]);

  const onFinishStep2 = (vals) => {

    setValues({...values, ...vals});

    setCurrent(3)
  };


  const onFinishStep3 = (vals) => {

    setValues({...values, ...vals});
    if (perfil === 1)
     setCurrent(4)
    else
      setCurrent(3)
  };


  const onFinishStep4 = (vals) => {
    if (noCaptcha) {
      let mBody = {...values, ...vals}
      setValues({...values, ...vals});
      setLoading(true);
      setError(false);
      mBody.profile = "COUNSELOR"
      if (perfil === 1) {
        mBody.profile = "TUTOR"
      }
      dispatch(tutorAuthActions.register(mBody));
      return
    }

    setErrorMsg("");

    const token = captchaRef.current.getValue();
    setError(false);
    setErrorMsg("")
    xcService.post("/v1/captcha", {token}).then(res => {
      captchaRef.current.reset();
      if (res.data.success) {

        let mBody = {...values, ...vals}

        setValues({...values, ...vals});
        setLoading(true);
        setError(false);
        mBody.profile = "COUNSELOR"
        if (perfil === 1){
          mBody.profile = "TUTOR"
        }
        dispatch(tutorAuthActions.register(mBody));


      } else {
        setError(true);
        setErrorMsg("captcha");
      }

    })
        .catch((error) => {
          captchaRef.current.reset();
        })



  };

  const onFinishCenter = (vals) => {
    if (noCaptcha) {
      setLoading(true);
      setError(false);
      dispatch(tutorAuthActions.registerCenter(vals));
      return;
    }

    const token = captchaRef.current.getValue();
    setError(false);
    setErrorMsg("")
    xcService.post("/v1/captcha", {token}).then(res => {
      captchaRef.current.reset();
      if (res.data.success) {

        setLoading(true);
        setError(false);
        dispatch(tutorAuthActions.registerCenter(vals));

      } else {
        setError(true);
        setErrorMsg("captcha");
      }

    })
        .catch((error) => {
          captchaRef.current.reset();
        })



  }

  const onChange = (value) => {

      setCurrent(value);
      document.getElementById('content-scrollable').scrollTop = 0;


  };

  useEffect(() => {
    if (current !== 0 && current !== 6) {

      if (values) {
        const {setFieldsValue, getFieldValue} = form;

        setFieldsValue(values);
      }
    }
  },[current]);

  const goTo = (perfil, step) => {
    setPerfil(perfil)
    setCurrent(step);
    let scrollContainers = document.querySelectorAll('.is-scrollable');
    scrollContainers.forEach( cont => cont.scrollTop = 0 );

  }

  const back = () => {

      setCurrent(current - 1)

  }


  const changeCenterCode = (e) => {

    if (e.target.value.length > 4) {
      setNameCenter(null)
      setErrorCenter(false);
      xcService.get("/v1/check/center/" + e.target.value)
          .then(({data}) => {

            setNameCenter(data.data)
            if (data.code === "3000"){
              // El cenro no existe

              setErrorCenter(true);
            }
          })
    } else {
      setNameCenter(null)
      setErrorCenter(false);
    }
  }
  return (
    <>
      <div className="containerRowRegister">
        <NavbarNoLogin className="menuNavRegister"/>
        <div className="colRegister leftRegister">
          <h1>{t("welcome")}</h1>
          <AuthBg/>
        </div>
        <div className="colRegister rightRegister">
          <div className="headerMobile">
            <h1>{t("welcome")}</h1>
          </div>

          <div className="containerRegister">
            <div className="centerRegister">
              {current !== 6 && (
                <h2>{t("registro.registro")}</h2>
              )}
              {current !== 6 && current !== 0 &&
                  <Steps

                      direction={"horizontal"}
                      responsive={false}
                      type="navigation"
                      size="small"
                      current={current}
                      onChange={onChange}
                      className="site-navigation-steps"
                  >
                    {perfil < 4 && <Step />}
                    {perfil < 4 && <Step disabled={ current + 1 < 2} />}
                    {perfil < 3 && <Step disabled={ current + 1 < 3} />}
                    {perfil < 3  && <Step disabled={ current + 1 < 4} />}
                    {perfil < 2  && <Step disabled={ current + 1 < 5} />}
                  </Steps>
              }
              {current === 0 && (
                <div className={"first-content is-scrollable is-scrollable--auth"}>

                  <div className="textDesc">{t("registro.perfil")}</div>
                  <div style={{ marginTop: 40 }} className="centerMobile">
                    <Button onClick={() => goTo(1,1)} className="primaryButton btnPrimaryWhite buttonSizeO"  type="primary">
                      {t("registro.tutor")}
                    </Button>
                  </div>
                  <div style={{ marginTop: 24 }}  className="centerMobile">
                    <Button   type="primary" onClick={() => goTo(2,1)} className="primaryButton btnPrimaryWhite  buttonSizeO">
                      {t("registro.orientador")}
                    </Button>
                  </div>
                  <div style={{ marginTop: 24 }}  className="centerMobile">
                    <Button   type="primary" onClick={() => goTo(3,1)} className="primaryButton btnPrimaryWhite buttonSizeO">
                      {t("registro.centro")}
                    </Button>
                  </div>
                  <div style={{ marginTop: 32 }} className="textDesc" dangerouslySetInnerHTML={{__html: t('registro.tienescuentay')}}/>
                </div>
              )}
              {perfil === 3 && current === 1 && (
                  <div className="allHeightMobile is-scrollable is-scrollable--auth">
                    <div className="textDesc margintop24">
                      {t("registro.datosacceso")}

                      <div className="subText" dangerouslySetInnerHTML={{__html: t('registro.datosaccesoinfo')}} />

                    </div>
                    <div className="customTextSmall is-required">{t("obligatorio")}</div>
                    <div className="margintop24 allHeightMobile">
                      <Form className="authForm allHeightMobile"  form={form}
                            onFinish={onFinishCenter}
                            name="basic"
                            layout="vertical"
                            labelCol={{ span: 18 }}
                            wrapperCol={{ span: 24, xl: 18 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                      >
                        <Form.Item
                            label={<div>{t("registro.codigoc")}&nbsp;
                                    <Tooltip  title={t("registro.tooltipcodigo")}>
                                      <QuestionCircleOutlined />
                                    </Tooltip></div>}
                            name="centerCode"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input onChange={changeCenterCode} placeholder={t("registro.codigoc")} />
                        </Form.Item>
                        {nameCenter && <div className={"infoCenterData"}>
                          <h4>{t("registercenter.nombrecentro")}</h4>
                          <p>
                            {nameCenter.name}<br/>
                            {nameCenter.address}<br/>

                          </p>
                        </div>}
                        <Form.Item
                            name="email"
                            label={<div>{t("registro.correocentro")}&nbsp;
                                    <Tooltip  title={t("registro.tooltipcorreocentro")}>
                                      <QuestionCircleOutlined />
                                    </Tooltip></div>}
                            rules={[
                              {
                                type: "email",
                                message: t("registro.emailIncorrect"),
                              },
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input placeholder={t("registro.correocentrop")} />
                        </Form.Item>
                        <Form.Item
                            name="emailrep"
                            label={t("registro.confirmacorreocentro")}
                            rules={[
                              {
                                type: "email",
                                message: t("registro.emailIncorrect"),
                              },
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (!value || getFieldValue('email') === value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error( t("registro.emailmis")));
                                },
                              }),
                            ]}
                        >
                          <Input placeholder={t("login.emailp")} />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label={<div>
                                <span>{t("registro.password")}</span>&nbsp;&nbsp;
                                <Tooltip title={t("registro.tooltipcentropassword")}>
                                  <QuestionCircleOutlined />
                                </Tooltip>
                            </div>}
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                              {
                                validator: async () => {
                                  return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                                },
                                message: errorMessage
                              }
                            ]}
                            hasFeedback
                        >
                          <PasswordInput
                              placeholder={t("registro.passwordp")}
                              onLevelChange={setLevel}
                              settings={{
                                height: 7, alwaysVisible: true, colorScheme: {
                                  levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                                  noLevel: "lightgrey"
                                }
                              }}
                          />

                        </Form.Item>

                        <Form.Item
                            name="acceptcentermanifiesta"
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                  acceptcentermanifiesta ? callback() : callback(t("registro.mustaccept"));
                                  },
                              },
                            ]}
                        >
                          <Checkbox checked={acceptcentermanifiesta} onChange={onAcceptCenterManifiestaChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkCenterManifiesta')}} />
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="acceptcenter"
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                  acceptcenter ? callback() : callback(t("registro.mustaccept"));
                                  },
                              },
                            ]}
                        >
                          <Checkbox checked={acceptcenter} onChange={onAcceptCenterChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkCenterAcepta')}} />
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="acceptcenterdeclara"
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                  acceptcenterdeclara ? callback() : callback(t("registro.mustaccept"));
                                  },
                              },
                            ]}
                        >
                          <Checkbox checked={acceptcenterdeclara} onChange={onAcceptCenterDeclara}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkCenterDeclara')}} />
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                          name="acceptmail"
                          rules={[
                            {
                              validator: (_, value, callback) => {
                                // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                acceptmail ? callback() : callback(t("registro.mustaccept"));
                              },
                            },
                          ]}

                        >
                          <Checkbox checked={acceptmail} onChange={onAcceptMailChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkMail')}} />
                          </Checkbox>
                        </Form.Item>

                        {showErrorCheck &&
                            <Row><Col span={24}>
                              <Alert message={t("registro.mustaccept")} type="error" />
                            </Col></Row>
                        }
                        { !noCaptcha &&
                        <ReCAPTCHA ref={captchaRef}
                                   sitekey={process.env.REACT_APP_SITE_KEY}
                        />
                        }
                        {error  &&
                            <Row><Col span={24}>
                              <Alert message={t(errorMsg)} type="error" />
                            </Col></Row>
                        }
                        <Form.Item className="buttons-pre-next">
                            <Button className="primaryButton buttonSizeS" onClick={() => setCurrent( current - 1 )} htmlType="button">{t("atras")}</Button>
                            <Button loading={loading}  className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                              {t("next")}
                            </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>

                )}
              {perfil !== 3 && current === 1 && (
                <div className="allHeightMobile is-scrollable is-scrollable--auth">
                  <div className="textDesc margintop24">
                    {t("registro.datoscentro")}
                  </div>
                  <div className="customTextSmall is-required">{t("obligatorio")}</div>
                  <div className="margintop24 allHeightMobile">
                    <Form className="authForm allHeightMobile"  form={form}
                          onFinish={onFinishStep1}
                      name="basic"
                      layout="vertical"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      initialValues={{ remember: true }}
                      autoComplete="off"
                    >
                      <Form.Item
                        label={<div>
                          <span>{t("registro.codigoc")}</span>&nbsp;&nbsp;
                          <Tooltip title={t("registro.tooltipcodigo")}>
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </div>}
                        name="centerCode"
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Input onChange={changeCenterCode}  placeholder={t("registro.codigoc")} />
                      </Form.Item>
                      {nameCenter && <div className={"infoCenterData"}>
                        <h4>{t("registercenter.nombrecentro")}</h4>
                        <p>
                          {nameCenter.name}<br/>
                          {nameCenter.address}<br/>

                        </p>
                      </div>}
                      <Form.Item
                        label={<div>
                            <span>{t("registro.clave")}</span>&nbsp;&nbsp;
                            <Tooltip title={perfil === 1 ? t("registro.tooltipclaveor") : t("registro.tooltipclavedir")}>
                              <QuestionCircleOutlined />
                            </Tooltip>
                        </div>}
                        name="passwordCenter"
                        rules={[
                          {
                            required: true,
                            message: t("mandatory"),
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder={t("registro.claveplaceholder")}
                        />

                      </Form.Item>

                      {errorCenter &&
                          <Row><Col span={24}>
                            <Alert message={codeError  ? t(codeError) : t("registro.errorCenter")} type="error" />
                          </Col></Row>
                      }

                      <Form.Item className="buttons-pre-next">
                          <Button className="primaryButton buttonSizeS" onClick={() => setCurrent(current - 1)} htmlType="button">{t("atras")}</Button>

                          <Button  loading={loading}  className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                            {t("next")}
                          </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              )}


              {current === 2 && perfil === 1 && (
                  <div className="allHeightMobile is-scrollable is-scrollable--auth">
                    <div className="textDesc margintop24">
                      {t("registro.datoscurso")}
                    </div>
                    <div className="customTextSmall is-required">{t("obligatorio")}</div>
                    <div className="margintop24 allHeightMobile">
                      <Form className="authForm allHeightMobile"  form={form}
                            onFinish={onFinishStep2}
                            name="basic"
                            layout="vertical"
                            // labelCol={{ span: 8 }}
                            // wrapperCol={{ span: 10 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                      >
                        <Form.Item
                            label={t("registro.courseplacetut")}
                            name="course_id"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                        <Select
                            placeholder={t("registro.courseplacetut")}
                            showSearch={true}
                            defaultActiveFirstOption={true}
                            filterOption={false}
                            notFoundContent={null}
                        >
                          {courses.map((d) => {
                            return (
                                <Option value={d.id} key={d.id}>
                                  {d.name}
                                </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                        <Form.Item
                            name="group"
                            label={t("registro.grupo")}
                            hasFeedback
                            rules={[{ required: true, message: t("mandatory") }]}
                        >
                          <Select placeholder={t("registro.grupo")}>
                            <Option value="A">A</Option>
                            <Option value="B">B</Option>
                            <Option value="C">C</Option>
                            <Option value="D">D</Option>
                            <Option value="E">E</Option>
                            <Option value="F">F</Option>
                            <Option value="G">G</Option>
                            <Option value="H">H</Option>
                            <Option value="I">I</Option>
                            <Option value="J">J</Option>
                            <Option value="K">K</Option>
                            <Option value="L">L</Option>
                            <Option value="M">M</Option>
                            <Option value="N">N</Option>
                            <Option value="O">O</Option>
                            <Option value="P">P</Option>
                            <Option value="Q">Q</Option>
                            <Option value="R">R</Option>
                            <Option value="S">S</Option>
                            <Option value="T">T</Option>
                            <Option value="U">U</Option>
                            <Option value="V">V</Option>
                            <Option value="W">W</Option>
                            <Option value="X">X</Option>
                            <Option value="Y">Y</Option>
                            <Option value="Z">Z</Option>
                          </Select>
                        </Form.Item>

                        <Form.List name={"groups"}>
                          {(fields, {add, remove}, {errors}) => (
                              <>

                                {fields.map((field, index) => (
                                    <>
                                      <Form.Item
                                          label={t("registro.curso")}
                                          name={[field.name, 'course']}
                                          rules={[
                                            {
                                              required: true,
                                              message: t("mandatory"),
                                            },
                                          ]}
                                      >
                                        <Select
                                            placeholder={t("registro.courseplacetut")}
                                            showSearch={true}
                                            defaultActiveFirstOption={true}
                                            filterOption={false}
                                            notFoundContent={null}
                                        >
                                          {courses.map((d) => {
                                            return (
                                                <Option value={d.id} key={d.id}>
                                                  {d.name}
                                                </Option>
                                            );
                                          })}
                                        </Select>
                                      </Form.Item>
                                      <Form.Item
                                          name={[field.name, 'group']}
                                          label={t("registro.grupo")}
                                          hasFeedback
                                          rules={[{ required: true, message: t("mandatory") }]}
                                      >
                                        <Select placeholder={t("registro.grupo")}>
                                          <Option value="A">A</Option>
                                          <Option value="B">B</Option>
                                          <Option value="C">C</Option>
                                          <Option value="D">D</Option>
                                          <Option value="E">E</Option>
                                          <Option value="F">F</Option>
                                          <Option value="G">G</Option>
                                          <Option value="H">H</Option>
                                          <Option value="I">I</Option>
                                          <Option value="J">J</Option>
                                          <Option value="K">K</Option>
                                          <Option value="L">L</Option>
                                          <Option value="M">M</Option>
                                          <Option value="N">N</Option>
                                          <Option value="O">O</Option>
                                          <Option value="P">P</Option>
                                          <Option value="Q">Q</Option>
                                          <Option value="R">R</Option>
                                          <Option value="S">S</Option>
                                          <Option value="T">T</Option>
                                          <Option value="U">U</Option>
                                          <Option value="V">V</Option>
                                          <Option value="W">W</Option>
                                          <Option value="X">X</Option>
                                          <Option value="Y">Y</Option>
                                          <Option value="Z">Z</Option>
                                        </Select>
                                      </Form.Item>
                                      <Form.Item className="alignBottomMobile">
                                        <Space  size={180} className="btnsForm">
                                          <Button
                                              type={"warning"}
                                              className="primaryButton"
                                              onClick={() => remove(field.name)}

                                              icon={<MinusCircleOutlined/>}
                                          >
                                            {t("registercenter.removegroup")}
                                          </Button>
                                        </Space>
                                      </Form.Item>
                                    </>
                                ))}
                                <Form.Item className="alignBottomMobile">
                                  <Space  size={180} className="btnsForm">
                                    <Button
                                        className="primaryButton"
                                        onClick={() => add()}

                                        icon={<PlusOutlined/>}
                                    >
                                      {t("registercenter.addgroup")}
                                    </Button>

                                  </Space>
                                </Form.Item>

                              </>
                          )}
                        </Form.List>

                        <Form.Item className="buttons-pre-next">
                            <Button className="primaryButton buttonSizeS" onClick={() => setCurrent(current - 1)} htmlType="button">{t("atras")}</Button>

                            <Button  className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                              {t("next")}
                            </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
              )}

              {( (current === 3 && perfil === 1 ) || (current === 2 && perfil === 2)) && (
                  <div className="allHeightMobile is-scrollable is-scrollable--auth">
                    <div className="textDesc margintop24">
                      {t("registro.datospersonales")}
                    </div>
                    {(perfil === 1) && (
                      <div className="customTextSmall">{t("registro.datosavalidar")}</div>
                    )}
                    {(perfil === 2) && (
                      <div className="customTextSmall">{t("registro.datosavalidarorientador")}</div>
                    )}
                    <div className="customTextSmall is-required">{t("obligatorio")}</div>
                    <div className="margintop24 allHeightMobile">
                      <Form className="authForm allHeightMobile"  form={form}
                            onFinish={onFinishStep3}
                            name="basic"
                            layout="vertical"
                            // labelCol={{ span: 8 }}
                            // wrapperCol={{ span: 10 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                      >
                        <Form.Item
                            label={t("registro.name")}
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input placeholder={t("registro.namep")} />
                        </Form.Item>
                        <Form.Item
                            label={t("registro.surname")}
                            name="surname"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input placeholder={t("registro.surnamep")} />
                        </Form.Item>
                        {/* ToDo: de momento se usa para Tutor y Orientador.
                        Tutor es OK
                        Orientador: es texto o desplegable? es Titulación o Formación (en doc es Formación?  */}
                        {/* {perfil === 1 && ( */}
                          <Form.Item
                              label={t("registro.titulacion")}
                              name="profession"
                              rules={[
                                {
                                  required: true,
                                  message: t("mandatory"),
                                },
                              ]}
                          >
                            <Input placeholder={t("registro.titulacionp")} />
                          </Form.Item>
                        {/* )} */}

                        <Form.Item
                            name="gender"
                            label={
                              <div>
                                <span>{t("registro.genero")}</span>&nbsp;&nbsp;
                              </div>
                            }
                            hasFeedback
                            rules={[{ required: true, message: t("mandatory") }]}
                        >
                          <Select placeholder={t("registro.generop")}>
                            <Option value="f">{t("login.mujer")}</Option>
                            <Option value="m">{t("login.hombre")}</Option>
                            <Option value="n">{t("login.otro")}</Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                            label={t("registro.dni")}
                            name="nif"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  var DNI_REGEX = /^(\d{8})([A-Z])$/;
                                  value = value.toUpperCase().replace(/\s/, '');
                                  if ( value.match( DNI_REGEX ) ) {
                                    var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                                    var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                                    if (letter === value.charAt(8))
                                      return Promise.resolve();
                                    else
                                      return Promise.reject(new Error(t("registro.baddni")));

                                  }else{
                                    return Promise.reject(new Error(t("registro.baddni")));
                                  }
                                },
                              }),
                            ]}
                        >
                          <Input placeholder={"12345678X"} />
                        </Form.Item>

                        <Form.Item
                            label={t("registro.telefono")}
                            name="phone"
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input placeholder={"XXX-XXX-XXX"} />
                        </Form.Item>


                        <Form.Item className="buttons-pre-next">
                            <Button className="primaryButton buttonSizeS"
                                    onClick={() => setCurrent(current-1)}
                                    htmlType="button">{t("atras")}</Button>

                            <Button  className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                              {t("next")}
                            </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
              )}
              {/* {(current === 4 && perfil === 1) && ( */}
              {( (current === 4 && perfil === 1) || (current === 3 && perfil === 2) ) && (
                  <div className="allHeightMobile is-scrollable is-scrollable--auth">
                    <div className="textDesc margintop24">
                      {t("registro.datosemail")}
                    </div>
                    <div className="customTextSmall is-required">{t("obligatorio")}</div>
                    <div className="margintop24 allHeightMobile">
                      <Form className="authForm allHeightMobile"  form={form}
                            onFinish={onFinishStep4}
                            name="basic"
                            layout="vertical"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            initialValues={{ remember: true }}
                            autoComplete="off"
                      >
                        <Form.Item
                            name="email"
                            label={t("registro.email")}
                            rules={[
                              {
                                type: "email",
                                message: t("registro.emailIncorrect"),
                              },
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                            ]}
                        >
                          <Input placeholder={t("login.emailp")} />
                        </Form.Item>
                        <Form.Item
                            name="emailrep"
                            label={t("registro.cemail")}
                            rules={[
                              {
                                type: "email",
                                message: t("registro.emailIncorrect"),
                              },
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (!value || getFieldValue('email') === value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error( t("registro.emailmis")));
                                },
                              }),
                            ]}
                        >
                          <Input placeholder={t("login.emailp")} />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label={t("registro.password")}
                            rules={[
                              {
                                required: true,
                                message: t("mandatory"),
                              },
                              {
                                validator: async () => {
                                  return level >= minLevel ? Promise.resolve() : Promise.reject(errorMessage);
                                },
                                message: errorMessage
                              }
                            ]}
                            hasFeedback
                        >
                          <PasswordInput
                              placeholder={t("registro.passwordp")}
                              onLevelChange={setLevel}
                              settings={{
                                height: 7, alwaysVisible: true, colorScheme: {
                                  levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
                                  noLevel: "lightgrey"
                                }
                              }}
                          />
                        </Form.Item>
                        <Form.Item
                            name="acceptconoce"
                            valuePropName="acceptconoce"
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                  acceptconoce ? callback() : callback(t("registro.mustaccept"));
                                  },
                              },
                            ]}

                        >
                          <Checkbox checked={acceptconoce} onChange={onAcceptConoceChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkConoce')}} />
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="acceptdeclara"
                            rules={[
                              {
                                validator: (_, value, callback) => {
                                  // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                  acceptdeclara ? callback() : callback(t("registro.mustaccept"));
                                  },
                              },
                            ]}

                        >
                          <Checkbox checked={acceptdeclara} onChange={onAcceptDeclaraChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkDeclara')}} />
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                          name="acceptmail"
                          rules={[
                            {
                              validator: (_, value, callback) => {
                                // acceptconoce ? Promise.resolve() : Promise.reject(new Error(t("mandatory")))
                                acceptmail ? callback() : callback(t("registro.mustaccept"));
                              },
                            },
                          ]}

                        >
                          <Checkbox checked={acceptmail} onChange={onAcceptMailChange}>
                            <div className="customTextSmall" dangerouslySetInnerHTML={{__html: t('registro.checkMail')}} />
                          </Checkbox>
                        </Form.Item>

                        { !noCaptcha &&
                        <ReCAPTCHA ref={captchaRef}
                                   sitekey={process.env.REACT_APP_SITE_KEY}
                        />
                        }

                        {error  &&
                            <Row><Col span={24}>
                              <Alert message={t(errorMsg)} type="error" />
                            </Col></Row>
                        }
                        <Form.Item className="buttons-pre-next">
                            <Button className="primaryButton buttonSizeS" onClick={() => setCurrent( current - 1)} htmlType="button">{t("atras")}</Button>
                            <Button loading={loading} className="primaryButton buttonSizeS" type="primary" htmlType="submit">
                              {t("next")}
                            </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
              )}


              {current === 6 && perfil === 3 && (
                    <div className={"finishRegister is-scrollable is-scrollable--auth"}>
                      <img className={"imgRegister center-text"} src={luxfi} height={144} />
                      <p className={"finish-text"}>{t("registro.finishcer")}</p>

                          <>
                          <p>{t("registro.finishcer1")}</p>
                            <p>{t("registro.finishcer2")}</p>
                          </>


                      <Button
                          onClick={() => history.push("/default/index")}
                          type={"primary"}
                          className="primaryButton buttonSizeO center-text"
                      >
                        {t("registro.gotoinicio") }
                      </Button>
                    </div>
                  )}
              {current === 6 && perfil !== 3 && (
                  <div className={"finishRegister is-scrollable is-scrollable--auth"}>
                    <img className={"imgRegister center-text"} src={luxfi} height={144} />
                    <p className={"finish-text"}>{t("registro.finishcer")}</p>
                    {perfil === 1 &&
                        <>
                          <p>{t("registro.finistutor1")}</p>
                          <p>{t("registro.finistutor2")}</p>
                        </>

                    }
                    {perfil === 2 &&
                        <>
                          <p>{t("registro.finisorientador")}</p>
                        </>

                    }

                    <Button
                        onClick={() => history.push("/default/index")}
                        type={"primary"}
                        className="primaryButton buttonSizeO center-text"
                    >
                      {t("registro.gotoinicio") }
                    </Button>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withTranslation()(RegisterPage);
